var React = require('react');

function TickInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_488","data-name":"Group 488","transform":"translate(0.817 0.454)"},[React.createElement("line",{"id":"Line_103","data-name":"Line 103","x2":"4","y2":"4","transform":"translate(-0.11 6.253)","fill":"none","stroke":"#000","strokeWidth":"2","key":0}),React.createElement("line",{"id":"Line_104","data-name":"Line 104","x1":"10","y2":"10","transform":"translate(2.89 0.253)","fill":"none","stroke":"#000","strokeWidth":"2","key":1})]));
}

TickInline.defaultProps = {"width":"14.414","height":"11.414","viewBox":"0 0 14.414 11.414"};

module.exports = TickInline;

TickInline.default = TickInline;
